import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { set } from "lodash";
import { ListFilterKey } from "../../utils/list/objects/listFilterKey";
import { ListFilterValue } from "../../utils/list/objects/listFilterValue";
import { ListNetworkData } from "../../utils/list/objects/listNetworkData";
import { ListPeriodFilterShortcut } from "../../utils/list/objects/listPeriodFilterShortcut";
import { NewsletterState } from "../objects/newsletterState";

const initialState: NewsletterState = {
    allContactGroups: {state: 'loading'},
    listData: {state: 'loading'},
    listFilters: {
        period: {
            type: 'CREATION',
            shortcut: ListPeriodFilterShortcut.NONE,
            values: {
                CREATION: {
                    LESS_THAN: new Date().toISOString(),
                    GREATER_THAN: new Date().toISOString(),
                },
                MODIFICATION: {
                    LESS_THAN: new Date().toISOString(),
                    GREATER_THAN: new Date().toISOString(),
                },
            }
        },
        pagination: {
            limit: 50,
            page: 0
        },
    },
};

const slice = createSlice({
    name: 'newsletter',
    initialState,
    reducers: {
        setAllContactGroups: (
            state,
            action: PayloadAction<NewsletterState['allContactGroups']>
        ): void => {
            state.allContactGroups = action.payload;
        },
        setListData: (
            state,
            action: PayloadAction<ListNetworkData>
        ): void => {
            state.listData = action.payload;
        },
        setListFiltersValue<K extends ListFilterKey>(
            state: NewsletterState,
            action: PayloadAction<{
                key: K,
                value: ListFilterValue<K>
            }>
        ): void {
            set(state.listFilters, action.payload.key, action.payload.value);
        },
    }
});

export const {
    setAllContactGroups,
    setListData,
    setListFiltersValue,
} = slice.actions;

export default slice;